
    import './styles.scoped.css';
    export default {
  "handle": "awsui_handle_19hnz_1inwv_9",
  "active": "awsui_active_19hnz_1inwv_26"
};
  